package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
actual fun rememberHapticVibration(): (durationMs: Long) -> Unit {
    return { durationMs ->
        if (HapticVibrationManager.isEnabled) {
            runCatching {
                window.navigator.vibrate(durationMs.toInt())
            }
        }
    }
}
